/* eslint-disable array-callback-return */
import {
  useBoolean,
  useToastr,
} from '@laxmimanogna/code-quick-components';
import { createContext, useEffect, useState } from 'react';
import { successToast } from '../components/successToast';
import { ROLES_VALUES } from '../constants/constants';
import { REBUTTAL_STATUS, RESOLVED_STATUS } from '../pages/audit_sheet/constants';
import auditSheetRepository from '../repositories/AuditSheetRepository';
import dashboardRepository from '../repositories/DashboardRepository';
import { toTitleCase } from '../utils/common.utils';

export const AuditSheetContext = createContext({
  isAuditSheetLoading: false,
  isAccessDenied: true,
  createAuditSheet: async () => {},
  getAuditSheet: async () => {},
  monitorAuditHour: async () => {},
  currentUpload: {},
  getAuditUpload: async () => {},
  updateAuditSheet: async () => {},
  getIndustryCodes: async () => {},
  getICDCodes: async () => {},
  getModifiers: async () => {},
  industryCodes: {},
  iCDCodes: {},
  modifiers: {},
  recentAuditImageUpload: async () => {},
  updateActivity: async () => {},
  getUsers: async () => {},
  getAllUsers: async () => {},
  getComments: async () => {},
  fetchComments: async () => [],
  comments: [],
  setComments: async () => {},
  users: [],
  allUsers: [],
  isUpdateActivityLoading: false,
  isUserLoading: false,
  isCommentLoading: false,
  allComments: [],
  setAllComments: () => {},
  getAllComments: async () => {},
  commentFilters: {},
  setCommentFilters: () => {},
  getCommentFlag: async () => {},
  commentFlags: [],
  getBatchAuditSheet: async () => {},
  setCommentFlags: () => {},
  selectedCell: {},
  setSelectedCell: () => {},
  deleteComment: async () => {},
  updateComment: async () => {},
  postComment: async () => {},
  isPostCommentLoading: false,
  isAllCommentLoading: false,
  totalComments: 0,
  getFileObjectByBatchId: async () => {},
  isFileLoading: false,
  providerOptions: [],
  fetchProviderDropdown: async () => {},
  responseAuditIssues: [],
  fetchResponseAuditIssues: async () => {},

  // new

  setAuditSheetColumnsKeys: () => {},
  setHilightedColumn: () => {},
  setDollorColumn: () => {},
  setAgreeDisAgreeCol: () => {},

  agreeDisAgreeCol: [],
  auditSheetColumnsKeys: [],
  dollarColumn: [],
  highlightedColumn: [],

  addNote: async () => {},
  sheetData: [],
  setSheetData: () => {},
});
const AuditSheetProvider = props => {
  const toast = useToastr();

  const [isAuditSheetLoading, iasState] = useBoolean(false);
  const [isAccessDenied, setAccessDeniedState] = useBoolean(true);
  const [currentUpload, setCurrentUpload] = useState({});
  const [industryCodes, setIndustryCode] = useState({});
  const [iCDCodes, setICDCode] = useState({});
  const [modifiers, setModifiers] = useState({});
  const [users, setUsers] = useState([]);
  const [isUpdateActivityLoading, iuaState] = useBoolean(false);
  const [isCommentLoading, icState] = useBoolean(false);
  const [isUserLoading, iuState] = useBoolean(false);
  const [allUsers, setAllUsers] = useState([]);

  // audit state version to resolve racing issues
  const [auditSheetVersion, setAuditSheetVersion] = useState(0);

  const [comments, setComments] = useState([]);
  const [allComments, setAllComments] = useState([]);
  const [commentFlags, setCommentFlags] = useState([]);
  const [isPostCommentLoading, ipclState] = useBoolean(false);
  const [isAllCommentLoading, iaclState] = useBoolean(false);
  const [selectedCell, setSelectedCell] = useState({});
  const [commentFilters, setCommentFilters] = useState({});
  const [totalComments, setTotalComments] = useState(0);
  const [isFileLoading, iflState] = useBoolean(false);
  const [providerOptions, setProviderOptions] = useState([]);
  const [responseAuditIssues, setResponseAuditIssues] = useState([]);
  const [sheetData, setSheetData] = useState([]);
  const [batchChartIds, setBatchChartIds] = useState([]);
  const [chartBatchId, setChartBatchId] = useState(null);
  const [batchRebuttalSummary, setBatchRebuttalSummary] = useState(null);
  const [batchChartStatuses, setBatchChartStatuses] = useState({});

  // new

  const [highlightedColumn, setHilightedColumn] = useState([]);

  const [dollarColumn, setDollorColumn] = useState([]);

  const [auditSheetColumnsKeys, setAuditSheetColumnsKeys] = useState([]);

  const [agreeDisAgreeCol, setAgreeDisAgreeCol] = useState([]);

  async function createAuditSheet(payload, uploadId) {
    try {
      const response = await auditSheetRepository.createAuditSheet(
        {version: auditSheetVersion,
        sheets: payload},
        uploadId
      );
      return response;
    } catch (err) {
      toast.showError({
        description: err.toString(),
        duration: 10000
      });
    }
  }
  async function updateAuditSheet(payload, uploadId) {
    try {
      iasState.on();
      const response = await auditSheetRepository.updateAuditSheet(
        {version: auditSheetVersion,
        sheets: payload},
        uploadId
      );
      return response;
    } catch (err) {
      toast.showError({
        description: err.toString(),
        duration: 10000
      });
    } finally {
      iasState.off();
    }
  }

  async function getAuditSheet(uploadId, queryParams = null) {
    try {
      iasState.on()
      const response = await auditSheetRepository.getAuditSheet(uploadId, queryParams);
      setAuditSheetVersion(response.version)
      setAccessDeniedState.off();
      return response.sheets;
    } catch (err) {
      if(err?.cause?.detail === "access_denied" || err?.cause?.detail == "Not found."){
        setAccessDeniedState.on();
      }
      else{
        setAccessDeniedState.off();
        toast.showError({
          description: err.toString(),
        });
      }
      return {error: err?.cause?.detail};
    } finally {
      iasState.off();
    }
  }
  async function getBatchAuditSheet(batchId, rendererId) {
    try {
      iasState.on()
      const QUERY_PARAMS = (rendererId) ? {'renderer_id': rendererId} : null;
      const response = await auditSheetRepository.getBatchAuditSheet(batchId, QUERY_PARAMS);
      setAccessDeniedState.off();
      return response;
    } catch (err) {
      if(err?.cause?.detail === "access_denied" || err?.cause?.detail === "Not found."){
        setAccessDeniedState.on();
      }
      else{
        setAccessDeniedState.off();
        toast.showWarning({
          description: err.toString(),
        });
      }
      return {error: err?.cause?.detail}
    } finally {
      iasState.off();
    }
  }
  async function getAuditUpload(uploadId) {
    try {
      iasState.on();
      const response = await auditSheetRepository.getAuditUpload(uploadId);
      setAccessDeniedState.off();
      if (Object.keys(response).length) {
        setCurrentUpload(response);
      }
      return response;
    } catch (err) {
      if(err?.cause?.detail === "access_denied" || err?.cause?.detail == "Not found."){
        setAccessDeniedState.on();
      } else {
        setAccessDeniedState.off();
        toast.showError({
          description: err.toString(),
        }); 
      }
      iasState.off();
      return {error: err?.cause?.detail};
    } finally {
      // iasState.off();
    }
  }

  async function monitorAuditHour(uploadId) {
    try {
      await auditSheetRepository.auditHourMonitor(uploadId);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    }
  }

  async function recentAuditImageUpload(uploadId, data) {
    try {
      await auditSheetRepository.recentAuditImageUpload(uploadId, data);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    }
  }

  async function getIndustryCodes(uploadId) {
    try {
      const response = await auditSheetRepository.getIndustryCodes();
      setIndustryCode(response);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    }
  }

  async function getICDCodes(uploadId) {
    try {
      const response = await auditSheetRepository.getICDCodes();
      setICDCode(response);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    }
  }

  async function getModifiers(uploadId) {
    try {
      const response = await auditSheetRepository.getModifiers();
      setModifiers(response);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    }
  }

  async function updateActivity(data) {
    try {
      iuaState.on();
      const response = await auditSheetRepository.updateActivity(data);
      if (data.length) {
        const updatedFlags = { ...commentFlags };
        data[0].row.map(rowId => {
          updatedFlags[rowId] = { ...(commentFlags[rowId] || {}) };
          data[0].column.forEach(col => { updatedFlags[rowId][col] = true; });
        });
        setCommentFlags(updatedFlags);
      }
      const toastProps = {
        header: 'Success!',
        description: `${
          data[0].action === REBUTTAL_STATUS
            ? 'Marked as rebuttal.'
            : !data[0].parent
            ? 'Comment sent'
            : 'Reply sent'
        }`,
      };
      successToast(toast, toastProps);
      return response;
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    } finally {
      iuaState.off();
    }
  }

  async function getUsers() {
    try {
      iuState.on();
      const response = await auditSheetRepository.getUsers();
      const userData = response.map(r => {
        return {
          id: r.id,
          display: `${r.first_name} ${r.last_name} | ${ROLES_VALUES[r.role]}`,
          first_name: r.first_name,
          last_name: r.last_name,
        };
      });
      setUsers([...userData]);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    } finally {
      iuState.off();
    }
  }

  async function getAllUsers() {
    try {
      iuState.on();
      const response = await auditSheetRepository.getAllUsers();
      const userData = response.map(r => {
        return {
          id: r.id,
          first_name: r.first_name,
          last_name: r.last_name,
        };
      });
      setAllUsers([...userData]);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    } finally {
      iuState.off();
    }
  }

  async function getComments(queryParams) {
    try {
      icState.on();
      const response = await auditSheetRepository.getComments(queryParams);
      if (response.results) {
        setComments(response.results);
      }
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    } finally {
      icState.off();
    }
  }
  // Fetches comments without overwriting the shared `comments` state
  async function fetchComments(queryParams) {
    try {
      const response = await auditSheetRepository.getComments(queryParams);
      return response.results || [];
    } catch (err) {
      return [];
    }
  }

  async function getAllComments() {
    try {
      iaclState.on();
      const { uploadId, batchId, ...queryParams } = commentFilters;
      let response;
      if (!uploadId && batchId) {
        response = await auditSheetRepository.getBatchAllComments(batchId, queryParams);
      } else {
        response = await auditSheetRepository.getComments(commentFilters);
      }
      let results = response.results || [];
      let totalCount = response.count || 0;

      // In single chart view, also fetch batch-level notes for the batch this chart belongs to.
      // Derive the batch ID from currentUpload (batch_id field) or fall back to any
      // comment that already carries a batch reference.
      if (commentFilters.uploadId && !commentFilters.batchId) {
        const derivedBatchId =
          currentUpload?.batch_id ||
          currentUpload?.batch ||
          chartBatchId ||
          results.find(c => c.batch)?.batch;
        if (derivedBatchId) {
          const batchResp = await auditSheetRepository.getComments({
            batchId: derivedBatchId,
            reverse: commentFilters.reverse,
            page: 1,
          }).catch(() => ({ results: [] }));
          if (batchResp.results?.length) {
            const existingIds = new Set(results.map(c => c.id));
            const newItems = batchResp.results.filter(c => !existingIds.has(c.id));
            results = [...results, ...newItems];
            // Do NOT add to totalCount — supplementary fetch should not affect pagination.
          }
        }
      }

      if (response.results) {
        setTotalComments(totalCount);
        if (commentFilters.page === 1) {
          setAllComments(results);
        }
        return results;
      }
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    } finally {
      iaclState.off();
    }
  }

  async function getCommentFlag({ uploadId, batchId }) {
    try {
      const response = await auditSheetRepository.getCommentFlag({
        uploadId,
        batchId,
      });
      const obj = {};
      if (response.length) {
        for (let i = 0; i < response.length; i++) {
          const comment = response[i];
          const rowId = comment[0];
          const colName = comment[1][0];
          const status = comment[1][1];
          const isOpen = !status || !RESOLVED_STATUS.includes(status);
          if (!obj[rowId]) obj[rowId] = {};
          obj[rowId][colName] = isOpen;
        }
      }
      setCommentFlags(obj);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    }
  }

  async function deleteComment(commentId, commentParentId, notes) {
    try {
      await auditSheetRepository.deleteComment(commentId);
      if (commentParentId) {
        setAllComments(prev => prev.map(c =>
          c.id === commentParentId
            ? { ...c, reply_comments: (c.reply_comments || []).filter(r => r.id !== commentId) }
            : c
        ));
      } else {
        setAllComments(prev => prev.filter(c => c.id !== commentId));
      }
      const toastProps = {
        header: 'Success!',
        description: `${notes ? 'Note' : 'Comment'} is deleted`,
      };
      successToast(toast, toastProps);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    }
  }
  async function updateComment(commentId, payload, commentParentId) {
    try {
      payload.action = 'UPDATE';
      await auditSheetRepository.editComment(commentId, payload);
      if (commentParentId) {
        setAllComments(prev => prev.map(c =>
          c.id === commentParentId
            ? {
                ...c,
                reply_comments: (c.reply_comments || []).map(r =>
                  r.id === commentId ? { ...r, comment: payload.comment } : r
                ),
              }
            : c
        ));
      } else {
        setAllComments(prev => prev.map(c =>
          c.id === commentId ? { ...c, comment: payload.comment } : c
        ));
      }
      const toastProps = {
        header: 'Success!',
        description: `${payload.notes ? 'Note' : 'Comment'} is updated`,
      };
      successToast(toast, toastProps);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    }
  }
  async function postComment(data) {
    try {
      ipclState.on();
      let response = {};
      if (!data.tagged_user) {
        data.tagged_user = [];
      }
      response = await auditSheetRepository.postComment(data);
      return response;
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    } finally {
      ipclState.off();
    }
  }
  const getFileObjectByBatchId = async (batchId, rendererId = null) => {
    try {
      iflState.on();
      let queryParams = null
      if (rendererId) {
        queryParams = {renderer_id: rendererId};
      }
      const response = await dashboardRepository.getFileObjectByBatchId(
        batchId,
        queryParams
      );
      return response;
    } catch (err) {
      toast.showError({
        description: `${err.toString()}.`,
      });
    } finally {
      iflState.off();
    }
  };

  async function fetchProviderDropdown(uploadId) {
    try {
      const response = await auditSheetRepository.getProviderDropdown(uploadId);
      setProviderOptions(
        response.map(p => ({
          id: p.provider_id,
          value: toTitleCase(`${p.first_name} ${p.last_name}`),
        }))
      );
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    }
  }

  async function addNote(data) {
    try {
      ipclState.on();
      let response = await auditSheetRepository.postComment(data);
      return response;
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    } finally {
      ipclState.off();
    }
  }

  async function fetchResponseAuditIssues() {
    try {
      const response = await auditSheetRepository.getResponseAuditIssues();
      setResponseAuditIssues(response);
    } catch (err) {
      toast.showError({
        description: err.toString(),
      });
    }
  }

  // chartIds must be passed directly — batchChartIds state may not yet be updated when called
  async function loadBatchRebuttalStatus(batchId, chartIds) {
    try {
      if (!chartIds?.length) {
        setBatchRebuttalSummary({ count: 0, charts: [] });
        setBatchChartStatuses({});
        return;
      }
      // Fetch the actual upload status for each chart (more reliable than comment thread analysis)
      const uploads = await Promise.all(
        chartIds.map(chartId =>
          auditSheetRepository.getAuditUpload(chartId).catch(() => null)
        )
      );
      const statuses = {};
      const inReviewCharts = [];
      uploads.forEach((upload, i) => {
        if (!upload) return;
        const key = String(chartIds[i]);
        statuses[key] = upload;
        const s = upload.status;
        if (s === 'CLIENT REBUTTAL' || s === 'REBUTTAL IN PROGRESS') {
          inReviewCharts.push({
            id: key,
            name: upload.file_name || upload.upload_id || `Chart ${key}`,
          });
        }
      });
      setBatchChartStatuses(statuses);
      setBatchRebuttalSummary({ count: inReviewCharts.length, charts: inReviewCharts });
    } catch (err) {
      // silent — status badge is informational only
    }
  }

  const mContext = {
    isAuditSheetLoading,
    isAccessDenied,
    createAuditSheet,
    getAuditSheet,
    monitorAuditHour,
    currentUpload,
    getAuditUpload,
    updateAuditSheet,
    getIndustryCodes,
    getICDCodes,
    getModifiers,
    industryCodes,
    iCDCodes,
    modifiers,
    recentAuditImageUpload,
    updateActivity,
    getUsers,
    getAllUsers,
    getComments,
    fetchComments,
    comments,
    setComments,
    users,
    allUsers,
    isUpdateActivityLoading,
    isUserLoading,
    isCommentLoading,
    allComments,
    setAllComments,
    commentFilters,
    setCommentFilters,
    getAllComments,
    getCommentFlag,
    commentFlags,
    getBatchAuditSheet,
    setCommentFlags,
    selectedCell,
    setSelectedCell,
    deleteComment,
    updateComment,
    postComment,
    isPostCommentLoading,
    isAllCommentLoading,
    totalComments,
    getFileObjectByBatchId,
    isFileLoading,
    providerOptions,
    fetchProviderDropdown,
    responseAuditIssues,
    fetchResponseAuditIssues,

    // new

    setAuditSheetColumnsKeys,
    setHilightedColumn,
    setDollorColumn,
    setAgreeDisAgreeCol,

    agreeDisAgreeCol,
    auditSheetColumnsKeys,
    dollarColumn,
    highlightedColumn,

    addNote,
    sheetData,
    setSheetData,
    setCurrentUpload,
    batchChartIds,
    setBatchChartIds,
    chartBatchId,
    setChartBatchId,
    batchRebuttalSummary,
    loadBatchRebuttalStatus,
    batchChartStatuses,
  };

  return (
    <AuditSheetContext.Provider value={mContext}>
      {props.children}
    </AuditSheetContext.Provider>
  );
};

export default AuditSheetProvider;
